import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageRefund() {
  const queryClient = useQueryClient();
  const { privateFetch } = useContext(FetchContext);

  function approveRefund({ refundId, note }) {
    // Approval now triggers an immediate automatic refund via the payment gateway.
    return privateFetch.put(`/v1/admin/refunds/${refundId}/approve`, { note });
  }

  function rejectRefund({ refundId, rejectionReason, note }) {
    return privateFetch.put(`/v1/admin/refunds/${refundId}/reject`, {
      rejectionReason,
      note,
    });
  }

  function exportRefunds(params = {}) {
    return privateFetch.get('/v1/admin/refunds/export', {
      params,
      responseType: 'blob',
    });
  }

  function manageRefund({ action, ...rest } = {}) {
    if (action === 'approve') return approveRefund(rest);
    if (action === 'reject') return rejectRefund(rest);
    throw new Error(`[useManageRefund] Unknown action: "${action}"`);
  }

  const mutation = useMutation(manageRefund, {
    onSettled() {
      queryClient.invalidateQueries('refunds-list');
      queryClient.invalidateQueries('refund-stats');
      queryClient.invalidateQueries('refund-detail');
    },
  });

  return { ...mutation, exportRefunds };
}

export default useManageRefund;
